import Stack from '@mui/material/Stack';
import { InsightsWarning } from './components/InsightsWarning/InsightsWarning.tsx';
import { MonthlyActiveReachEstimates } from './components/MonthlyActiveReachEstimates/MonthlyActiveReachEstimates.tsx';
import { MonthlyDeviceEstimates } from './components/MonthlyDeviceEstimates/MonthlyDeviceEstimates.tsx';
import { MonthlyRequestEstimates } from './components/MonthlyRequestEstimates/MonthlyRequestEstimates.tsx';
import { PublisherSection } from './components/PublisherSection/PublisherSection.tsx';
import { AudienceInsightsProvider } from './context/AudienceInsightsProvider.tsx';
import { useAudienceInsights } from './context/audienceInsights.ts';

const AudienceInsightsContent = () => {
  const { isDisabled } = useAudienceInsights();

  return (
    <Stack>
      {isDisabled && <InsightsWarning />}
      <PublisherSection />

      {!isDisabled && (
        <>
          <MonthlyActiveReachEstimates />
          <MonthlyDeviceEstimates />
          <MonthlyRequestEstimates />
        </>
      )}
    </Stack>
  );
};

export function AudienceInsightsTab() {
  return (
    <AudienceInsightsProvider>
      <AudienceInsightsContent />
    </AudienceInsightsProvider>
  );
}
